(function () {
  const DRAWER_SELECTOR = 'nss-drawer[nss-drawer-id="quick-add"]';

  function reinjectScripts(root) {
    root.querySelectorAll('script').forEach((old) => {
      const fresh = document.createElement('script');
      for (const attr of old.attributes) fresh.setAttribute(attr.name, attr.value);
      if (!old.src) fresh.textContent = old.textContent;
      old.replaceWith(fresh);
    });
  }

  function waitForStyles(root, timeout = 2500) {
    const links = Array.from(root.querySelectorAll('link[rel="stylesheet"]'));
    const pending = links.filter((link) => !link.sheet);
    if (!pending.length) return Promise.resolve();
    const loaded = Promise.all(
      pending.map(
        (link) =>
          new Promise((resolve) => {
            link.addEventListener('load', resolve, { once: true });
            link.addEventListener('error', resolve, { once: true });
          })
      )
    );
    return Promise.race([loaded, new Promise((resolve) => setTimeout(resolve, timeout))]);
  }

  async function load(trigger) {
    const url = trigger.getAttribute('data-qa-url');
    if (!url) return;

    const drawer = document.querySelector(DRAWER_SELECTOR);
    if (!drawer) return;
    const body = drawer.querySelector('[data-qa-body]');
    if (!body) return;

    const openDrawer = () => {
      if (typeof drawer.open === 'function') drawer.open();
    };

    if (body.getAttribute('data-loaded-url') === url) {
      openDrawer();
      return;
    }

    trigger.classList.add('is-loading');
    trigger.setAttribute('aria-busy', 'true');
    body.setAttribute('data-loading', '');
    body.removeAttribute('data-loaded-url');
    body.innerHTML = '';

    try {
      const res = await fetch(url);
      if (!res.ok) throw new Error('HTTP ' + res.status);
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const section = doc.querySelector('[id^="shopify-section-"]') || doc.body;

      body.innerHTML = '';
      body.appendChild(section);
      reinjectScripts(body);
      body.setAttribute('data-loaded-url', url);

      const panel = drawer.querySelector('.nss-drawer__panel');
      if (panel) panel.scrollTop = 0;

      await waitForStyles(body);

      openDrawer();
    } catch (err) {
      console.error('[NSS][QuickAdd] Failed to load:', err);
      body.innerHTML =
        '<p class="nss-body nss-quick-add-drawer__error">Sorry, this product could not be loaded right now.</p>';
      openDrawer();
    } finally {
      body.removeAttribute('data-loading');
      trigger.classList.remove('is-loading');
      trigger.removeAttribute('aria-busy');
    }
  }

  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-qa-url]');
    if (!trigger) return;
    e.preventDefault();
    load(trigger);
  });
})();
